import React, { useState } from 'react';
import { testimonials } from '../../data/homeContent';

function HomeTestimonials() {
  const [index, setIndex] = useState(0);
  const item = testimonials[index];

  return (
    <section className="home-section home-quotes">
      <div className="container">
        <div className="home-section-head home-center-head">
          <p className="home-kicker">TESTIMONIALS</p>
          <h2>We go the extra miles together</h2>
        </div>
        <blockquote className="home-quote">
          <p>“{item.quote}”</p>
          <footer>
            <strong>{item.name}</strong>
            <span>{item.org}</span>
          </footer>
        </blockquote>
        <div className="home-quote-nav">
          {testimonials.map((entry, i) => (
            <button
              key={entry.name}
              type="button"
              className={i === index ? 'is-active' : ''}
              aria-label={entry.name}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeTestimonials;
